export const PATHS = {
  DASHBOARD: 'dashboard',
  ANALYSE: 'analysis',
}
